import React from "react";
import { FaMapMarkerAlt, FaInfoCircle } from "react-icons/fa";
import Footer from "../minicomponents/Footer";
import { useTranslation } from "react-i18next";

const showsData = [
  {
    id: 1, // This show is now in the past
    date: "2025-05-25", // PAST
    time: "19:00",
    venue: "Dorpskerk",
    city: "Capelle aan den IJssel",
    cityLink: `https://maps.app.goo.gl/hAyuDF1m7X8cD2QT9?g_st=aw`,
    // ticketLink: "https://example.com/tickets/dorpskerk-2025-05-25",
    isFree: true, // Assuming this was a paid show if it had a ticket link like this
    soldOut: false,
  },
  {
    id: 2,
    date: "2025-08-24",
    time: "11:00",
    venue: "Essepark",
    title: "Live at Essepark",
    city: "Nieuwekerk aan den IJssel",
    cityLink: `https://maps.app.goo.gl/swSgYVSJXgddzYcg7`,
    isFree: true,
    soldOut: false,
  },
  {
    id: 3,
    date: "2026-04-12",
    time: "19:00",
    venue: "Dorpskerk",
    title: "Jongerendienst",
    city: "Zevenhuizen",
    cityLink: `https://maps.app.goo.gl/E32es4tVKdcFPjYY7`,
    isFree: true,
    soldOut: false,
  },
  {
    id: 4,
    date: "2026-06-14",
    time: "10:00",
    venue: "Bergen op zoom",
    title: "Jongerendienst",
    city: "Bergen op zoom",
    cityLink: ``,
    isFree: true,
    soldOut: false,
  },
  {
    id: 5,
    date: "2026-08-30",
    time: "18:30",
    venue: "Fonteinkerk",
    title: "Jongerendienst",
    city: "Krimpen a/d IJssel",
    cityLink: `https://maps.app.goo.gl/5qZscZ7kJY7XSi9z8`,
    isFree: true,
    soldOut: false,
  },
];

const formatDate = (dateString) => {
  const options = { year: "numeric", month: "long", day: "numeric" };
  return new Date(dateString + "T00:00:00Z").toLocaleDateString(
    "nl-NL",
    options
  );
};

const ShowCard = ({ show, isPastShow, formatDate, t }) => {
  return (
    <div
      className={`relative p-6 border rounded-lg shadow-xl text-left flex flex-col sm:flex-row justify-between items-start sm:items-center transition-all duration-300
      ${
        isPastShow
          ? "bg-gray-800/50 border-gray-700/60 opacity-60 hover:shadow-lg"
          : "bg-gray-800 border-gray-700 hover:shadow-2xl hover:border-gray-600"
      }`}
    >
      {show.ticketLink && (
        <FaInfoCircle
          className={`absolute top-4 right-4 text-2xl cursor-pointer transition-colors duration-200
        ${
          isPastShow
            ? "text-gray-600 hover:text-gray-500"
            : "text-gray-500 hover:text-teal-300"
        }`}
          title={
            isPastShow
              ? t("shows.played", "Show Played")
              : t("shows.moreInfo", "More show information")
          }
        />
      )}

      <div className="flex-grow mb-4 sm:mb-0 pr-8">
        <p
          className={`text-2xl font-semibold ${
            isPastShow ? "text-gray-300" : "text-white"
          }`}
        >
          {formatDate(show.date)}
          {show.time && (
            <span
              className={`text-lg font-normal ${
                isPastShow ? "text-gray-500" : "text-gray-400"
              }`}
            >
              {" "}
              - {show.time}
            </span>
          )}
        </p>
        <p
          className={`text-xl mt-1 ${
            isPastShow ? "text-gray-400" : "text-gray-300"
          }`}
        >
          {show.venue} {show.title && <span className="text-md text-slate-400 font-normal">({show.title})</span>}
        </p>
        {show.city && (
          <div
            className={`flex items-center text-md mt-2 ${
              isPastShow ? "text-gray-500" : "text-gray-400"
            }`}
          >
            {show.cityLink ? (
              <a
                href={show.cityLink}
                target="_blank"
                rel="noopener noreferrer"
                title={`View map for ${show.venue} in ${show.city}`}
                className={`flex items-center gap-2 group ${
                  isPastShow
                    ? "text-gray-500 hover:text-gray-400"
                    : "text-teal-400 hover:text-teal-300"
                } transition duration-300`}
                aria-label={`View map for ${show.venue} in ${show.city}`}
              >
                <FaMapMarkerAlt
                  className={`text-xl transition-colors duration-300 ${
                    isPastShow
                      ? "text-gray-600 group-hover:text-gray-400"
                      : "text-teal-500 group-hover:text-teal-300"
                  }`}
                />
                <span>{show.city}</span>
              </a>
            ) : (
              <>
                <FaMapMarkerAlt
                  className={`text-xl mr-2 ${
                    isPastShow ? "text-gray-600" : "text-gray-500"
                  }`}
                />
                <span>{show.city}</span>
              </>
            )}
          </div>
        )}
      </div>

      <div className="mt-4 sm:mt-0 sm:ml-6 flex flex-col items-stretch sm:items-end gap-3 self-center sm:self-auto">
        {isPastShow ? (
          <span className="inline-block text-gray-500 font-semibold py-3 px-6 rounded-md border-2 border-gray-600 text-center whitespace-nowrap">
            {t("shows.played", "Show Played")}
          </span>
        ) : show.isFree ? (
          show.ticketLink ? (
            <a
              href={show.ticketLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block text-teal-300 font-semibold py-3 px-6 rounded-md border-2 border-teal-500 hover:bg-teal-500 hover:text-gray-900 transition-all duration-300 text-center whitespace-nowrap"
              title="Optional: Register or get more info for this free event"
            >
              {t("shows.freeRegister", "Free Event (Info/Register)")}
            </a>
          ) : (
            <span className="inline-block text-green-400 font-semibold py-3 px-6 rounded-md border-2 border-green-500 text-center whitespace-nowrap">
              {t("shows.freeEntry", "Free Entry")}
            </span>
          )
        ) : show.ticketLink ? (
          <a
            href={show.ticketLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-teal-600 text-white font-semibold py-3 px-6 rounded-md hover:bg-teal-700 transition duration-300 whitespace-nowrap shadow-md hover:shadow-lg text-center"
          >
            {t("shows.getTickets", "Get Tickets")}
          </a>
        ) : (
          <span className="inline-block bg-gray-700 text-gray-400 font-semibold py-3 px-6 rounded-md whitespace-nowrap text-center cursor-not-allowed">
            {t("shows.ticketsSoon", "Tickets Soon")}
          </span>
        )}
      </div>
    </div>
  );
};

function ShowsPage() {
  const { t } = useTranslation();
  const currentDate = new Date();
  currentDate.setUTCHours(0, 0, 0, 0); // Set to UTC midnight for accurate date comparison

  const upcomingShows = showsData
    .filter((show) => new Date(show.date + "T00:00:00Z") >= currentDate)
    .sort((a, b) => new Date(a.date) - new Date(b.date)); // Next show first (ascending)

  const pastShows = showsData
    .filter((show) => new Date(show.date + "T00:00:00Z") < currentDate)
    .sort((a, b) => new Date(b.date) - new Date(a.date)); // Most recent show first (descending)

  return (
    <div
      className="pt-24 md:pt-28 pb-16 px-4 md:px-8 bg-gray-900 text-white min-h-screen"
      id="shows"
    >
      <div className="pb-32 max-w-4xl mx-auto text-center">
        <h1
          className="alt-font text-4xl sm:text-5xl lg:text-6xl font-extrabold mb-8 text-white"
          style={{ textShadow: "1px 1px 3px rgba(0,0,0,0.5)" }}
        >
          {t("shows.title", "Shows")}
        </h1>
        <p className="mt-4 mb-16 text-lg sm:text-xl text-gray-300 max-w-2xl mx-auto">
          {t("shows.description", "Find out where we're playing next or check out our show history. Join us in spreading faith, hope, and love.")}
        </p>

        {/* Upcoming Shows Section */}
        <div className="mb-20 text-left">
          <h2 className="text-2xl sm:text-3xl font-bold mb-8 text-teal-400 border-b border-gray-800 pb-3 flex items-center gap-3">
            <span className="w-2.5 h-2.5 rounded-full bg-teal-400 animate-ping"></span>
            {t("shows.upcoming", "Upcoming Shows")}
          </h2>
          {upcomingShows.length > 0 ? (
            <div className="space-y-6">
              {upcomingShows.map((show) => (
                <ShowCard key={show.id} show={show} isPastShow={false} formatDate={formatDate} t={t} />
              ))}
            </div>
          ) : (
            <div className="p-8 bg-gray-800/40 border border-gray-800 rounded-lg shadow-xl text-left">
              <p className="text-lg text-gray-400">
                {t("shows.noShows", "No shows scheduled at the moment. Please check back soon or follow us on Instagram for the latest updates!")}
              </p>
              <a
                href="https://www.instagram.com/LiveTheWill"
                target="_blank"
                rel="noopener noreferrer"
                className="mt-6 inline-block bg-teal-600 text-white font-semibold py-2.5 px-6 rounded-full hover:bg-teal-700 transition duration-300"
              >
                {t("footer.followUs", "Follow us")} on Instagram
              </a>
            </div>
          )}
        </div>

        {/* Past Shows Section */}
        {pastShows.length > 0 && (
          <div className="text-left">
            <h2 className="text-2xl sm:text-3xl font-bold mb-8 text-gray-400 border-b border-gray-800 pb-3">
              {t("shows.past", "Gespeelde Shows")}
            </h2>
            <div className="space-y-6">
              {pastShows.map((show) => (
                <ShowCard key={show.id} show={show} isPastShow={true} formatDate={formatDate} t={t} />
              ))}
            </div>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}

export default ShowsPage;
